import { Routes } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { ServicesComponent } from './components/services/services.component';
import { HeaderComponent } from './shared/header/header.component';
import { FormDataBasicComponent } from './components/form-data-basic/form-data-basic.component';
import { ErrorComponent } from './shared/error/error.component';
import { AddressComponent } from './components/address/address.component';
import { BalanceComponent } from './components/balance/balance.component';
import { ForeignComponent } from './components/foreign/foreign.component';
import { SignComponent } from './components/sign/sign.component';
import { FinishComponent } from './components/finish/finish.component';
import { PapComponent } from './components/pap/pap.component';
import { ForeignCheckComponent } from './components/foreign-check/foreign-check.component';
import { routeGuard } from './guards/route.guard';
import { PapCashComponent } from './components/pap-cash/pap-cash.component';
import { FinishPapComponent } from './components/finish-pap/finish-pap.component';

export const routes: Routes = [
      {
        path: 'consultor/:internalCode',
        component: HomeComponent,
      },
      {
        path: 'foreignCheck',
        component: ForeignCheckComponent,
      },
      {
        path: 'app',
        component: HeaderComponent,
        children: [

          {
            path: 'services',
            component: ServicesComponent,
            canActivate: [routeGuard]
          },
          {
            path: 'basic',
            component: FormDataBasicComponent,
            canActivate: [routeGuard]
          },
          {
            path: 'address',
            component: AddressComponent,
            canActivate: [routeGuard]
          },
          {
            path: 'balance',
            component: BalanceComponent,
            canActivate: [routeGuard]
          },
          {
            path: 'foreign',
            component: ForeignComponent,
            canActivate: [routeGuard]
          },
          {
            path: 'sign',
            component: SignComponent,
            canActivate: [routeGuard]
          },
          {
            path: 'finish',
            component: FinishComponent,
            canActivate: [routeGuard]
          },
          {
            path: 'pap',
            component: PapComponent,
            canActivate: [routeGuard]
          },
          {
            path: 'pap-cash',
            component: PapCashComponent,
            canActivate: [routeGuard]
          },
          {
            path: 'pap-finish',
            component: FinishPapComponent,
            canActivate: [routeGuard]
          },
        ]
      },
      {
        path: 'error',
        component: ErrorComponent,
      },
      {
        path: '**',
        component: HomeComponent,
      },
];
